import React from "react";
import styled from "styled-components";
import { BlobBlock, Title, AsideIcon } from "./index-styled";
import ScriptIcon from "_c/icon/Script";
import PinIcon from "_c/icon/Pin";
import PlusIcon from "_c/icon/Plus";
import { Link as RouterLink } from "react-router-dom";
import { CircleButton } from "_c/button";
import isempty from "lodash/isEmpty";
import Info from "_c/atoms/Info";
import { LinkGenerator } from "@/utils/LinkGenerator";
import qs from "query-string";

const Li = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  max-width: 100%;
  overflow: hidden;
  svg {
    width: 13px;
    min-width: 13px;
  }
  @media (max-width: 575px) {
    text-align: left;
  }
`;
const Link = styled(RouterLink)`
  color: var(--font-color-accent);
  margin-left: 5px;
  word-wrap: break-word;
`;
const EnhancedTitle = styled(Title)`
  margin-bottom: 30px;
  @media (max-width: 991px) {
    margin-bottom: 20px;
  }
  @media (max-width: 991px) {
    margin-bottom: 30px;
  }
`;
const EnhancedBlock = styled(BlobBlock)`
  min-height: 200px;
  height: auto;
  max-height: auto;
  ul {
    max-height: 300px;
    overflow-y: auto;
    margin-bottom: 5px;
    ::-webkit-scrollbar-track {
      background-color: white;
      border-radius: 45px;
    }
    ::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
      border-radius: 45px;
    }
    ::-webkit-scrollbar-thumb {
      background-image: var(--grad-primary-n);
      border-radius: 45px;
    }
  }
`;
const ArticleBlock = ({ t, ...props }) => (
  <EnhancedBlock>
    <AsideIcon>
      <ScriptIcon color="var(--font-color-emp)" />
    </AsideIcon>
    <EnhancedTitle>{t("master_profile:blocks_titles:blog")}</EnhancedTitle>
    {isempty(props.articles) ? (
      <Info>
        {props.isOwner
          ? t("master_profile:blocks_empty.blog_user")
          : t("master_profile:blocks_empty.blog_guest")}
      </Info>
    ) : (
      <ul>
        {props.articles.map(({ title, _id, slug }) => (
          <Li key={_id}>
            <PinIcon color="var(--font-color-emp)" />
            <Link
              to={qs.stringifyUrl({
                url: LinkGenerator.blogArticle(slug),
                query: { hl: props.hl },
              })}
            >
              {title}
            </Link>
          </Li>
        ))}
      </ul>
    )}
    {props.isOwner && (
      <CircleButton greenish small as={RouterLink} to="/blog/editor">
        <PlusIcon width="10" color="white" />
      </CircleButton>
    )}
  </EnhancedBlock>
);

export default ArticleBlock;
